import { Toaster } from "sonner";
import { useEffect } from "react";
import { initGA } from "@/lib/analytics";
import { Navbar } from "@/components/landing/Navbar";
import { Mission } from "@/components/landing/Mission";
import { SabbathQuotes } from "@/components/landing/SabbathQuotes";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { Teachings } from "@/components/landing/Teachings";
import { Timeline } from "@/components/landing/Timeline";
import { Sabbath } from "@/components/landing/Sabbath";
import { Paul } from "@/components/landing/Paul";
import { History } from "@/components/landing/History";
import { Watch } from "@/components/landing/Watch";
import { Scripture } from "@/components/landing/Scripture";
import { Reflect } from "@/components/landing/Reflect";
import { About } from "@/components/landing/About";
import { Join } from "@/components/landing/Join";
import { Footer } from "@/components/landing/Footer";

export default function Landing() {
  useEffect(() => {
    document.title = "The Restoration — The Original Gospel of Christ";
    initGA();
  }, []);

  return (
    <div data-testid="landing-page" className="bg-[#0A0A0A] text-[#F4F0EA]">
      <Toaster theme="dark" position="top-center" richColors />
      <Navbar />
      <Mission />
      <Reflect />
      <SabbathQuotes />
      <main>
        <Hero />
        <Marquee />
        <Teachings />
        <Timeline />
        <Sabbath />
        <Paul />
        <History />
        <Watch />
        <Scripture />
        <About />
        <Join />
      </main>
      <Footer />
    </div>
  );
}
